import { DocumentNode, OperationVariables, QueryHookOptions, TypedDocumentNode, useQuery } from "@apollo/client";
import { Spinner } from "@shopify/polaris";
import moment from "moment";
import React from "react";
import { Graph } from "src/generated/graph";

interface Props {
  query: DocumentNode | TypedDocumentNode<any, OperationVariables>;
  option: QueryHookOptions;
  queryName: string;
}

const mapSupplierDisbursementList = (data: Graph.Query) => {
  const items = [];
  for (const item of data.supplierDisbursementList?.data!) {
    items.push({
      Item: item.amount
        ? item.description
        : `${item.order_uuid},\nSupplier Code: ${item.supplier_code},\nL192 Code: ${item.code}`,
      "Order Date": moment(item.order_date).format("YYYY-MM-DD"),
      Stock: item.sku ? item.sku.stockQty : null,
      Color: item.sku ? item.sku.option1 : "",
      Size: item.sku ? item.sku.option2 : "",
      "Barcode (Supplier SKU)": item.sku ? item.sku.barcode : "",
      "Sale Price": item.full_price ? item.full_price : 0,
      discount: (((item.discounted | 0) - (item.promo_discount | 0)) | 0).toFixed(2),
      "Delivery Fee": item.delivery_fee ? item.delivery_fee : 0,
      "Handling Fee": item.handling_fee ? item.handling_fee : 0,
      Commission: item.l192_commission ? item.l192_commission : 0,
      "Net Sale": item.amount
        ? -Math.abs(Number(item.amount || 0))
        : Number(item.full_price ? item.full_price : 0)! -
          (Number(item.delivery_fee ? item.delivery_fee : 0) +
            Number(item.handling_fee ? item.handling_fee : 0) +
            Number(item.l192_commission ? item.l192_commission : 0)),
    });
  }
  return items;
};

const mapsupplierOrderBalance = (data: Graph.Query) => {
  const items = [];
  for (const item of data.supplierOrderBalance?.data!) {
    items.push({
      Item: item.amount
        ? item.description
        : `${item.order_uuid},\nSupplier Code: ${item.supplier_code},\nL192 Code: ${item.code}`,
      "Order Date": moment(item.order_date).format("YYYY-MM-DD"),
      Stock: item.sku ? item.sku.stockQty : null,
      Color: item.sku ? item.sku.option1 : "",
      Size: item.sku ? item.sku.option2 : "",
      "Barcode (Supplier SKU)": item.sku ? item.sku.barcode : "",
      "Sale Price": item.full_price ? item.full_price : 0,
      discount: (((item.discounted | 0) - (item.promo_discount | 0)) | 0).toFixed(2),
      "Delivery Fee": item.delivery_fee ? item.delivery_fee : 0,
      "Handling Fee": item.handling_fee ? item.handling_fee : 0,
      Commission: item.l192_commission ? item.l192_commission : 0,
      "Net Sale": item.amount
        ? -Math.abs(Number(item.amount || 0))
        : Number(item.full_price ? item.full_price : 0)! -
          (Number(item.delivery_fee ? item.delivery_fee : 0) +
            Number(item.handling_fee ? item.handling_fee : 0) +
            Number(item.l192_commission ? item.l192_commission : 0)),
    });
  }
  return items;
};

export function DownloadExcel(props: Props) {
  const { data, loading } = useQuery(props.query, props.option);

  const onClickDownload = () => {
    if (data) {
      import("xlsx").then((xlsx) => {
        let items: any[] = [];

        if (props.queryName === "supplierDisbursementList") {
          items = mapSupplierDisbursementList(data);
        }

        if (props.queryName === "supplierOrderBalance") {
          items = mapsupplierOrderBalance(data);
        }

        let ws = xlsx.utils.json_to_sheet(items);
        let wb = xlsx.utils.book_new();
        xlsx.utils.book_append_sheet(wb, ws, "Report");
        xlsx.writeFile(wb, "report.xlsx", {
          cellStyles: true,
        });
      });
    }
  };

  return (
    <button
      onClick={onClickDownload}
      disabled={loading}
      className="btn btn-sm text-light"
      style={{ backgroundColor: "#004200" }}
    >
      <span style={{ display: "flex" }}>{loading && <Spinner size="small" />} Download Excel</span>
    </button>
  );
}

/*
import("xlsx").then((XLSX) => {
      let dataConvert = items.map((item: any) => {
        return {
          "Item ID": item.itemid,
          English: item.title_english,
          Khmer: item.title_khmer,
          Chinese: item.title_chinese,
          "Supplier Code": item.supplier_code,
          "L192 Code": item.code,
          "Sale Price": item.price,
          "Discount (%)": item.discount,
          Discontinue: item.discontinue,
        };
      });

      let ws = XLSX.utils.json_to_sheet(dataConvert);
      let wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Product");
      XLSX.writeFile(wb, "product.xlsx");
    });
*/
